import { StyleSheet } from 'react-native';
import { BLUE_COLOR, OVERLAY_TITLE_COLOR } from 'coooltv-js-shared/src/styles/common';

const styles = StyleSheet.create({
    button_wrapper: {
        marginTop: 20,
        borderBottomWidth: 2,
        borderStyle: 'solid',
        borderColor: BLUE_COLOR,
        width: '90%',
        alignSelf: 'center',
    },
    button: {
        borderBottomWidth: 4,
        borderStyle: 'solid',
        borderColor: BLUE_COLOR,
        marginBottom: -4,
        alignSelf: 'center',
        paddingHorizontal: 10,
        paddingVertical: 5,
        backgroundImage: `linear-gradient(White, White 50%, ${BLUE_COLOR} 50%, ${BLUE_COLOR})`,
        backgroundSize: '100% 200%',
        transition: 'background-position .7s',
    },
    button_on_hover: {
        borderBottomWidth: 4,
        borderStyle: 'solid',
        borderColor: BLUE_COLOR,
        marginBottom: -4,
        alignSelf: 'center',
        paddingHorizontal: 10,
        paddingVertical: 5,
        backgroundImage: `linear-gradient(White, White 50%, ${BLUE_COLOR} 50%, ${BLUE_COLOR})`,
        backgroundSize: '100% 200%',
        transition: 'background-position .7s, color .7s',
        backgroundPosition: '0 100%',
        color: OVERLAY_TITLE_COLOR,
    },
    button_off_hover: {
        borderBottomWidth: 4,
        borderStyle: 'solid',
        borderColor: BLUE_COLOR,
        marginBottom: -4,
        alignSelf: 'center',
        paddingHorizontal: 10,
        paddingVertical: 5,
        backgroundImage: `linear-gradient(White, White 50%, ${BLUE_COLOR} 50%, ${BLUE_COLOR})`,
        backgroundSize: '100% 200%',
    },
    text: {
        color: BLUE_COLOR,
        fontSize: 18,
        marginBottom: 10,
    },
    text_on_hover: {
        color: OVERLAY_TITLE_COLOR,
        fontSize: 18,
        marginBottom: 10,
        transition: 'background-position .7s, color .7s',
    },
});

export default styles;
